var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconGreenLoanClean40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0029 8.75V10.8666",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8862 8.75V10.8666",
    stroke: "#1E1E1E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6445 24.4994H29.6337C30.7383 24.4994 31.6337 23.604 31.6337 22.4994V15.3418",
    stroke: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1194 11.0662C35.1194 10.9558 35.0298 10.8662 34.9194 10.8662H28.9695C28.8591 10.8662 28.7695 10.9558 28.7695 11.0662V12.6301C28.7695 13.9939 30.191 15.0994 31.9444 15.0994C33.6979 15.0994 35.1194 13.9939 35.1194 12.6301V11.0662Z",
    stroke: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22656 27.5469H10.5605V30.333C10.5605 31.5297 9.59026 32.4999 8.39349 32.4999C7.19673 32.4999 6.22656 31.5297 6.22656 30.333V27.5469Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0854 27.5469H25.4193V30.333C25.4193 31.5297 24.4491 32.4999 23.2524 32.4999C22.0556 32.4999 21.0854 31.5297 21.0854 30.333V27.5469Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33449 14.0202L6.69092 19.4988H24.955L23.3115 14.0202C23.1846 13.5972 22.7953 13.3076 22.3536 13.3076H9.29232C8.85071 13.3076 8.46139 13.5972 8.33449 14.0202Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8958 28.4753H3.75V23.2128C3.75 19.9933 6.84562 18.9821 8.39343 18.8789H23.2524C26.9671 18.8789 27.8958 21.7681 27.8958 23.2128V28.4753Z",
    fill: "#1A7D1A",
    stroke: "#1E1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1796 23.832C11.1796 24.8578 10.3479 25.6894 9.32239 25.6894C8.29649 25.6894 7.46484 24.8578 7.46484 23.832C7.46484 22.8061 8.29649 21.9746 9.32239 21.9746C10.3479 21.9746 11.1796 22.8061 11.1796 23.832Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1811 23.832C24.1811 24.8578 23.3494 25.6894 22.3239 25.6894C21.298 25.6894 20.4663 24.8578 20.4663 23.832C20.4663 22.8061 21.298 21.9746 22.3239 21.9746C23.3494 21.9746 24.1811 22.8061 24.1811 23.832Z",
    fill: "white",
    stroke: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconGreenLoanClean40);
export default __webpack_public_path__ + "static/media/pictogramBeaconGreenLoanClean40.ce2f8e1747fae24482691c29c41b5a73.svg";
export { ForwardRef as ReactComponent };